import * as Sentry from '@sentry/browser'
import SentryRRWeb from '@sentry/rrweb'
import {BrowserTracing} from '@sentry/tracing'
import {Config} from '../../config.js'

Sentry.init({
	dsn             : Config.sentry.dsn,
	environment     : Config.environment,
	tracesSampleRate: Config.sentry.sample_rate,
	integrations    : [
		new BrowserTracing(),
		new SentryRRWeb(),
	],
})

require('../../style/vendor/tailwind.css')

window.$ = window.jQuery = require('jquery')

require('@fortawesome/fontawesome-free/css/all.min.css')

require('animate.css/animate.min.css')

require('chart.js/dist/chart.min.js')

require('daterangepicker/daterangepicker.css')
require('daterangepicker/daterangepicker.js')

require('izitoast/dist/css/iziToast.min.css')
require('izitoast/dist/js/iziToast.min.js')

require('jfilestyle/src/jquery-filestyle.min.css')
require('jfilestyle/src/jquery-filestyle.min.js')

require('lazyload/lazyload.min.js')

require('pretty-checkbox/dist/pretty-checkbox.min.css')

require('remodal/dist/remodal.css')
require('remodal/dist/remodal-default-theme.css')
require('remodal/dist/remodal.min.js')

require('select2/dist/css/select2.min.css')
require('select2/dist/js/select2.min.js')

require('sortablejs/Sortable.min.js')

require('@sweetalert2/theme-wordpress-admin/wordpress-admin.min.css')
require('sweetalert2/dist/sweetalert2.min.js')

require('tablefilter/dist/tablefilter/tablefilter.js')

require('tablesorter/dist/js/jquery.tablesorter.min.js')

require('../../style/*.styl')
require('../../style/vendor/*.styl')
require('./style/*.styl')

window.App = {
	_common  : require('./client/_common.js').default,
	Index: require('./client/index.js').default,

	common: {
		Date   : require('../../client/date.js').default,
		Form   : require('../../client/form.js').default,
		Helper : require('../../client/helper.js').default,
		Image  : require('../../client/image.js').default,
		Is     : require('../../client/is.js').default,
		Log    : require('../../client/log.js').default,
		Network: require('../../client/network.js').default,
		Table  : require('../../client/table.js').default,
		Toast  : require('../../client/toast.js').default,
		Ui     : require('../../client/ui.js').default,
	},
}
